import { render, staticRenderFns } from "./SelectDressProduct.vue?vue&type=template&id=f87a8abe&scoped=true"
import script from "./SelectDressProduct.vue?vue&type=script&lang=js"
export * from "./SelectDressProduct.vue?vue&type=script&lang=js"
import style0 from "./SelectDressProduct.vue?vue&type=style&index=0&id=f87a8abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87a8abe",
  null
  
)

export default component.exports